<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn v-if="markedRecords.length != 0" class="ml-0" color="success" @click="markAsPaidClick">
					<v-icon small>fa-dollar-sign</v-icon>&nbsp;&nbsp;{{ $t('buttons.markAsPaid') }}
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card class="elevation-0 background-transparent">
					<DataTable
						:additional-filters="suppliersTable.additionalFilters"
						:excel="true"
						:headers="suppliersTable.headers"
						:items="suppliersTable.items"
						:total="suppliersTable.total"
						@excel="excelExport"
						@reload="reloadData"
					>
						<template #row="props">
							<tr :key="JSON.stringify(props.item)" :class="{'tour-cancelled-row': (props.item.cancelled == 1), 'cursor-pointer': true, 'cancelled-row': (props.item.cancelled_by != null)}"
								@contextmenu.prevent="editClick(props.item.id, true)">
								<td>
									<v-checkbox v-if="props.item.paid_date == null" v-model="markedRecords"
												:value="props.item.tour_service_id"
												hide-details></v-checkbox>
								</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.id }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.tour_name }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.tour_category }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.destination }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.start_date_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.subject }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.supplier_service }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.price_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.quantity_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.total_amount_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.due_date_display }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.paid_amount_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.paid_date_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.payment_account }}</td>
								<td class="text-xs-right" @click="editClick(props.item.id, false)">{{ props.item.unpaid_amount_display }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.transaction_id }}</td>
								<td @click="editClick(props.item.id, false)">{{ props.item.notes }}</td>
								<td>
									<v-tooltip v-if="props.item.paid_date == null" bottom>
										<v-btn slot="activator" icon
											   @click="addPaymentClick(props.item.tour_service_id)">
											<v-icon small>fa-money-bill-alt</v-icon>
										</v-btn>
										<span>{{ $t('tooltips.recordPayment') }}</span>
									</v-tooltip>
								</td>
							</tr>
						</template>
						<template #footer>
							<tr>
								<td colspan="10"></td>
								<td class="text-xs-right">{{ suppliersTable.sumTotal }}</td>
								<td></td>
								<td class="text-xs-right">{{ suppliersTable.sumPaid }}</td>
								<td colspan="2"></td>
								<td class="text-xs-right">{{ suppliersTable.sumUnpaid }}</td>
								<td colspan="3"></td>
							</tr>
						</template>
					</DataTable>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";
import Payment from "./modals/Payment";
import DatePicker from "./trinkets/DatePicker";

export default {
	name: "CashFlowSuppliers",
	components: {DatePicker, DataTable, Payment},
	data: function () {
		return {
			suppliersTable: {
				headers: [
					{
						text: '',
						value: 'selection',
						type: '',
						sortable: false,
						align: "left",
						width: "50px",
						searchable: false
					},
					{text: this.$t('fields.tourId'), value: 'tour_id', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.tourName'), value: 'tour_name', type: 'string', searchable: 'hidden'},
					{
						text: this.$t('fields.tourCategory'),
						value: 'tour_category_id',
						type: 'dropdown|tour-categories',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.destination'),
						value: 'destination_id',
						type: 'dropdown|destinations',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.tourStartDate'),
						value: 'start_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.supplierName'),
						value: 'subject_id',
						type: 'dropdown|subjects-suppliers',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.supplierService'),
						value: 'supplier_service',
						type: 'string',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.price'),
						value: 'price',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.quantity'),
						value: 'quantity',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.totalAmount'),
						value: 'total_amount',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.dueDate'),
						value: 'due_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.paidAmount'),
						value: 'paid_amount',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.paidDate'),
						value: 'paid_date',
						type: 'date_range',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.account'),
						value: 'payment_account_id',
						type: 'dropdown|payment-accounts',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.unpaidAmount'),
						value: 'unpaid_amount',
						type: 'price_range',
						searchable: 'hidden', class: 'text-xs-right'
					},
					{
						text: this.$t('fields.transactionId'),
						value: 'transaction_id',
						type: 'string',
						searchable: 'hidden'
					},
					{
						text: this.$t('fields.notes'),
						value: 'notes',
						type: 'string',
						searchable: 'hidden'
					},
					{
						text: '',
						value: 'actions',
						type: '',
						sortable: false,
						align: "right",
						width: "210px",
						searchable: false
					}
				],
				additionalFilters: [
					{
						text: this.$t('fields.completelyPaid'),
						value: 'completely_paid',
						type: 'boolean',
						searchable: 'hidden'
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				sumPaid: 0,
				sumUnpaid: 0,
				sumTotal: 0
			},
			markedRecords: []
		}
	},
	methods: {
		markAsPaidClick() {
			let vm = this;
			this.$date(this.$t('labels.recordPayment'), this.$t('fields.date'), null, (result) => {
				if (result !== false) {
					vm.$APICall('post', 'tours-services/mark-as-paid', {
						records: this.markedRecords,
						date: result
					}, (data, success) => {
						if (success) {
							vm.markedRecords = [];
							vm.reloadData(vm.suppliersTable.lastRequest);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		addPaymentClick(serviceId) {
			let vm = this;
			this.$date(this.$t('labels.recordPayment'), this.$t('fields.date'), null, (result) => {
				if (result !== false) {
					vm.$APICall('post', 'tours-services/mark-as-paid', {
						records: [serviceId],
						date: result
					}, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicAdd'));
							vm.reloadData(vm.suppliersTable.lastRequest);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/tours/' + id)
			} else {
				let routeData = this.$router.resolve('/tours/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		reloadData(request) {
			this.suppliersTable.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'cash-flow-suppliers', request, (data, success) => {
				if (success) {
					vm.markedRecords = [];
					vm.suppliersTable.items = data.items;
					vm.suppliersTable.total = data.total;
					vm.suppliersTable.sumTotal = data.sum_total_display;
					vm.suppliersTable.sumPaid = data.sum_paid_display;
					vm.suppliersTable.sumUnpaid = data.sum_unpaid_display;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.suppliersTable.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'cash-flow-suppliers', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/cash-flow-suppliers', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			}, false);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Reporting');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.cashFlowSuppliers'), href: '/#/cash-flow-suppliers', disabled: true}
		]);
	}
}
</script>

<style scoped>
.cancelled-row {
	color: #ff0000;
}

.tour-cancelled-row td {
	text-decoration: line-through;
}

.tour-cancelled-row td:first-child {
	text-decoration: none;
}

.tour-cancelled-row td:last-child {
	text-decoration: none;
}
</style>
